// @flow
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { FormattedMessage } from 'react-intl';
import moment from 'moment';
import { LoadingContentStripe } from '../../../../../elements/LoadingContentFigures/LoadingContentFigures';
import { CommaFormat } from '../../../../../elements/Price/Price';
import type {BagItem, ShoppingCartItem} from '../../../../../entities';
import RadioButton from '../CustomRadioButton/RadioButton';
import { RadioButtonLoading } from '../../../../../elements/RadioButton/RadioButton';

import style from './ClassicDeliveryTime.scss';
import loadingStripeStyle from '../../../../../elements/LoadingContentFigures/LoadingContentFigures.scss';

import type { DeliveryTier, ForecastTier } from '../../api';
import type { Node } from 'react';

type Props = {
  +items: (ShoppingCartItem | BagItem)[];
  +forecast: ForecastTier[];
  +handleChangeOption: (option: number) => void;
  +isEditingItem?: boolean;
  +isLoadingForecast?: boolean;
  +selectedIndex?: number;
  +isLoadingItems?: boolean;
};

type State = {};

export const ClassicDeliveryTimeLoading = ({ className }: { className: string }) => (
  <div className={classNames(style.option, style.itemsLoading, className)}>
    <RadioButtonLoading/>
    <div className={style.content}>
      <LoadingContentStripe colorClassName={loadingStripeStyle.black200}/>
      <LoadingContentStripe colorClassName={loadingStripeStyle.black50}/>
    </div>
  </div>
);

export default class ClassicDeliveryTime extends Component<Props, State> {
  // This total is amount
  buildOption(tier: DeliveryTier, index: number, total: number, selectedIndex?: number) {
    const { handleChangeOption } = this.props;
    let date = '--, ----';
    date = moment().add(tier.days, 'days').utc().format('MMMM DD, YYYY', { trim: false });
    let subtitle = (
      <FormattedMessage id="newOrder.quote.classic.deliveryTime.before">{
        txt => <p className={style.optionDays}>{txt} {date}</p>
      }</FormattedMessage>);

    let tierName = tier.name.toLowerCase();

    if (tierName === 'flexible') {
      tierName = 'newOrder.quote.classic.deliveryTime.travelers';
    } else if (tierName === 'fast') {
      tierName = 'newOrder.quote.classic.deliveryTime.fullOption.tier.name === \'FLEXIBLE\'';
    }

    return [
      <div key={index}
           className={classNames(style.option, { [style.active]: index === selectedIndex })}
           onClick={_ => handleChangeOption(index)}>
        <RadioButton checked={selectedIndex === index}
                     name="shipping"/>
        <div className={style.content}>
          <FormattedMessage id={tierName}>{
            txt => <p className={style.optionTitle}>{txt}</p>
          }</FormattedMessage>
          <p className={style.optionTotal}>&nbsp;{total ? `- $ ${CommaFormat({ price: total })}` : '---'}</p>
          {subtitle}
        </div>
        {tier.name === 'FLEXIBLE' && <div className={style.noTax}>
          <span>
            Sin impuestos
          </span>
        </div>}
      </div>,
      total,
    ];
  }
  
  shouldIncludeDeliveryTime(forecastTier: ForecastTier, items: (ShoppingCartItem | BagItem)[]): boolean {
    for (let item of items) {
      const itemsWeightCriteria = [5, 2, 8, 14, 13, 17, 7, 9, 15, 10].includes(item.itemCategoryId);
      // more then 8lbs
      if (itemsWeightCriteria && parseFloat(item.weight) > 3.62874) {
        if (forecastTier.tier.name === 'FLEXIBLE') return false;
      }
    }
    return true;
  }

  render() {
    const { forecast, isEditingItem, isLoadingForecast, selectedIndex, isLoadingItems, items } = this.props;
    /*    const date = typeof selectedIndex !== 'undefined' &&
          moment().add(forecast[selectedIndex].tier.days, 'days').format('MMM DD, YYYY');*/
    if (isLoadingItems) {
      return (
        <Fragment>
          <div className={classNames(style.optionsWrap)}>
            {[0, 1, 2].map((_: number, n: number) =>
              <ClassicDeliveryTimeLoading key={n}
                                          className={classNames({ [style.xSmallHidden]: n === 2 })}/>)}
          </div>
          {/*<FormattedMessage id="newOrder.quote.deliveryDate">{
            txt => <p className={style.deliveryDate}>
              <i className={classNames(icons.iconDeliverBoxMedium)}/>
              {txt}:
            </p>
          }</FormattedMessage>*/}
          <LoadingContentStripe colorClassName={
            classNames(loadingStripeStyle.black50, style.deliveryDateItemsLoading)}/>
        </Fragment>
      );
    }
    const deliveryOptions = forecast/*.sort((a: ForecastTier, b: ForecastTier) => {
      const totalServicesCostA = parseFloat(a.importationFee) +
        parseFloat(a.customsDuties) +
        parseFloat(a.qempo) +
        parseFloat(a.lastMileShipping);
      const totalServicesCostB = parseFloat(b.importationFee) +
        parseFloat(b.customsDuties) +
        parseFloat(b.qempo) +
        parseFloat(b.lastMileShipping);
      return totalServicesCostB - totalServicesCostA;
    })*/
      .filter((forecastTier: ForecastTier) => this.shouldIncludeDeliveryTime(forecastTier, items))
      .map((forecastTier: ForecastTier, index: number) => {
        const totalServicesCost = parseFloat(forecastTier.importationFee) +
          parseFloat(forecastTier.customsDuties) +
          parseFloat(forecastTier.qempo) +
          parseFloat(forecastTier.lastMileShipping);
        return this.buildOption(
          forecastTier.tier,
          index,
          totalServicesCost,
          selectedIndex,
        );
      });
      

    return (<Fragment>
      <div className={classNames(style.optionsWrap, { [style.loading]: isLoadingForecast || isEditingItem })}>
        {deliveryOptions
          .sort((a: [Node, number], b: [Node, number]) => b[1] - a[1])
          .map((a: [Node, number]) => a[0])}
      </div>
      {/*<FormattedMessage id="newOrder.quote.deliveryDate">{
        txt => <p className={style.deliveryDate}>
          <i className={classNames(icons.iconDeliverBoxMedium)}/>
          {txt} <span>{date ? date : '--, --'}</span>
        </p>
      }</FormattedMessage>*/}
    </Fragment>);
  }
}

ClassicDeliveryTime.propTypes = {
  items: PropTypes.array.isRequired,
  forecast: PropTypes.array.isRequired,
  handleChangeOption: PropTypes.func.isRequired,
  isEditingItem: PropTypes.bool,
  isLoadingForecast: PropTypes.bool,
  selectedIndex: PropTypes.number,
  isLoadingItems: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./src/modules/new-order/QuoteStep/components/ClassicDeliveryTime/ClassicDeliveryTime.jsx